module.exports = __webpack_public_path__ + "static/media/ios.5b5690fa.png";